
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/candidate/matches/generating",
      function () {
        return require("private-next-pages/candidate/matches/generating/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/candidate/matches/generating"])
      });
    }
  